import { Checkbox as AntdCheckbox } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { CheckboxProps } from 'antd';

export const Checkbox = createGuardedComponent(AntdCheckbox) as typeof AntdCheckbox;
